import React from 'react'

export default function Nodata() {
  return (
    <div className='nodata'><p>No Data</p></div>
  )
}
